module.exports = __webpack_public_path__ + "static/banner-aduanal-571081c65f1e9d5c22ae6f2ca4a463cf.jpg";